/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { Card } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import { getContent } from './bazaarVoiceUtil';

const BazaarVoiceCarousel = ({
  itemId,
  siteName,
  lazyLoadGallery = false,
  cardBorder = false
}) => {
  const [mounted, setMounted] = useState(false);
  const [status, setStatus] = useState(null);
  // expects a truthy value
  // to determine if the BazaarVoiceCarousel should be rendered
  const fsEnabled = useConfigService(
    'fs-prop:bv-social-media-carousel-enabled'
  );
  useEffect(() => {
    if (!mounted) {
      setMounted(true);
    }
    const loadScript = async () => {
      const { status: statusResponse } = await getContent({ siteName });
      setStatus(statusResponse);
    };
    if (fsEnabled) {
      loadScript();
    }
  }, [siteName, fsEnabled]);

  if (!fsEnabled || !mounted || status !== 'LOADED') {
    return null;
  }

  return (
    <Card
      PaperProps={{
        variant: cardBorder ? 'border' : 'shadow',
      }}
      CardContentProps={{
        className: 'sui-w-full',
      }}
    >
      <div
        data-testid="bazaarVoiceCarousel"
        data-crl8-container-id="product"
        data-crl8-filter={`productId:'${itemId}'`}
        data-crl8-lazy-load-experience={`${lazyLoadGallery}`}
      />
    </Card>
  );
};

BazaarVoiceCarousel.propTypes = {
  itemId: string.isRequired,
  siteName: string.isRequired,
  lazyLoadGallery: bool,
  cardBorder: bool,
};

BazaarVoiceCarousel.displayName = 'BazaarVoiceCarousel';

BazaarVoiceCarousel.dataModel = {};

export { BazaarVoiceCarousel };
